"use client";
import { jsx as a } from "react/jsx-runtime";
import { memo as l } from "react";
import t from "../components/Icon/SvgIcon.js";
const e = (o) => /* @__PURE__ */ a(
  t,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...o,
    children: /* @__PURE__ */ a(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.708 6.345a1.2 1.2 0 0 0-.95-.45H6.995L6.335 2.5a.62.62 0 0 0-.61-.5H2.62a.62.62 0 0 0-.62.62.61.61 0 0 0 .62.609h2.596l2.518 13.814a.62.62 0 0 0 .609.51H18.72a.61.61 0 0 0 .61-.62.61.61 0 0 0-.61-.61H8.862l-.26-1.418a1 1 0 0 0 .25.05h10.039a1.79 1.79 0 0 0 1.738-1.448l1.349-6.133a1.23 1.23 0 0 0-.27-1.029m-2.287 6.902a.57.57 0 0 1-.53.48H8.902a.61.61 0 0 1-.55-.49L7.185 7.124H20.74zm-7.452 6.473a1.518 1.518 0 1 1-3.037 0 1.518 1.518 0 0 1 3.037 0m6.572 0a1.518 1.518 0 1 1-3.036 0 1.518 1.518 0 0 1 3.036 0",
        clipRule: "evenodd"
      }
    )
  }
), n = l(e);
export {
  n as Cart,
  n as default
};
